(() => {
  'use strict';

  if (window.__IHColorCompareLoadedV9) return;
  window.__IHColorCompareLoadedV9 = true;

  const FALLBACK_COLORS = [
    ['cozy greige', '#d6cec1'], ['greige', '#d6cec1'],
    ['pure white', '#f7f3ea'], ['silk white', '#f4efe4'], ['white', '#f7f3ea'], ['blanc', '#f7f3ea'],
    ['natural oak', '#d7b179'], ['oak', '#d7b179'],
    ['dreamy gray', '#b8b8b8'], ['dreamy grey', '#b8b8b8'], ['stone grey', '#adada9'], ['grey', '#a9a9a6'], ['gray', '#a9a9a6'],
    ['stormy gray', '#777777'], ['stormy grey', '#777777'], ['graphite', '#41413d'],
    ['mystic mud', '#7a7568'], ['deep black', '#0d0d0d'], ['black', '#0d0d0d'], ['schwarz', '#0d0d0d'],
    ['sea blue', '#254e7c'], ['navy blue', '#254e7c'], ['blue', '#254e7c'],
    ['soft berry', '#bf7783'], ['rosewood', '#b96f7d'], ['rose', '#bf7783'],
    ['moss green', '#566319'], ['matcha green', '#9bb665'], ['olive', '#8c9d5d'], ['green', '#526029'],
    ['golden sunrise', '#f4a21c'], ['sunrise', '#f4a21c'], ['terracotta', '#b35d2d'], ['choco brown', '#6d5343'], ['mango', '#f4a21c'], ['orange', '#f4a21c'],
    ['sand', '#d9ccb4'], ['beige', '#d8ccb8']
  ];

  /**
   * Farbfilter-Konfiguration
   * ------------------------------------------------------------
   * Hier könnt ihr die Farben pro Filter pflegen. Eine Farbe darf in
   * mehreren Gruppen vorkommen, z. B. cozy greige = neutral + warm.
   * Wichtig: Namen kleinschreiben, exakt wie im Shop oder als eindeutiger
   * Teil des Farbnames.
   */
  const COLOR_GROUPS = {
    neutral: ['cozy greige', 'pure white', 'silk white', 'dreamy gray', 'dreamy grey', 'stormy gray', 'stormy grey', 'deep black', 'black'],
    warm: ['cozy greige', 'natural oak', 'oak', 'choco brown', 'chocolate brown'],
    dark: ['stormy gray', 'stormy grey', 'deep black', 'black', 'mystic mud'],
    accent: ['moss green', 'soft berry', 'sea blue', 'golden sunrise', 'matcha green']
  };

  const DEFAULT_I18N = {
    available: 'Available now',
    unavailable: 'Unavailable',
    partial: 'Other size available',
    soldoutVariant: 'Sold out for selected size'
  };

  const SELECTORS = {
    root: '[data-ih-color-compare]',
    open: '[data-ih-color-compare-open]',
    close: '[data-ih-color-compare-close]',
    overlay: '[data-ih-color-compare-overlay]',
    dialog: '.ih-color-compare__dialog',
    card: '[data-ih-color-card]',
    status: '[data-ih-color-card-status]',
    filter: '[data-ih-color-filter]',
    productJson: '[data-ih-color-product-json]',
    configJson: '[data-ih-color-config-json]',
    currentColor: '[data-ih-current-color]',
    previewImage: '[data-ih-color-preview-image]',
    previewSwatch: '[data-ih-color-preview-swatch]',
    previewName: '[data-ih-color-preview-name]',
    previewStatus: '[data-ih-color-preview-status]',
    apply: '[data-ih-color-apply]',
    connectedProductJson: '[data-ih-connected-product-json]'
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const parseJSON = (node, fallback = {}) => {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[IH Color Compare] JSON could not be parsed', error);
      return fallback;
    }
  };

  const cssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const dispatchNativeChange = (element) => {
    if (!element) return;
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const fallbackColorForName = (name) => {
    const key = normalize(name);
    const match = FALLBACK_COLORS.find(([needle]) => key.includes(needle));
    return match ? match[1] : '#d6cec1';
  };

  const colorGroupsForName = (name) => {
    const color = normalize(name);
    const groups = Object.entries(COLOR_GROUPS)
      .filter(([, needles]) => needles.some((needle) => color.includes(normalize(needle))))
      .map(([group]) => group);

    // Fallback for new colors that are not yet explicitly configured above.
    if (groups.length) return groups;
    if (['black', 'deep', 'graphite', 'navy', 'dark', 'stormy', 'mystic'].some((needle) => color.includes(needle))) return ['dark'];
    if (['oak', 'wood', 'mango', 'terra', 'orange', 'brown', 'choco', 'beige'].some((needle) => color.includes(needle))) return ['warm'];
    if (['green', 'olive', 'moss', 'matcha', 'blue', 'berry', 'pink', 'yellow', 'sunrise'].some((needle) => color.includes(needle))) return ['accent'];
    return ['neutral'];
  };

  const cardMatchesGroup = (card, group) => {
    if (group === 'all') return true;
    return String(card.dataset.group || '')
      .split(/\s+/)
      .filter(Boolean)
      .includes(group);
  };

  const uniqueNodes = (nodes) => Array.from(new Set(nodes.filter(Boolean)));

  const isActuallyVisible = (element) => {
    if (!element || !(element instanceof Element)) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const focusable = (container) => {
    if (!container) return [];
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((el) => el.offsetParent !== null || el === document.activeElement);
  };

  const labelLooksLikeMainColor = (text) => {
    const value = normalize(text).replace(/\s+/g, ' ');
    const isStrap = ['band', 'strap', 'ribbon', 'cord', 'kordel', 'anhänger', 'anhaenger', 'hanger', 'lint', 'ruban', 'nastro'].some((word) => value.includes(word));
    if (isStrap) return false;

    // Best case: a short row such as "Farbe: cozy greige" or "Color: cozy greige".
    if (/(^|\b)(farbe|color|colour|couleur|colore|kleur)\s*[:：]/.test(value)) return true;

    return ['farbe', 'color', 'colour', 'couleur', 'colore', 'kleur'].some((word) => value === word || value.startsWith(`${word} `));
  };


  const optionKey = (value) => normalize(value).replace(/[：:]/g, '').replace(/\s+/g, ' ').trim();

  const optionValueKey = (value) => normalize(value).replace(/\s+/g, '');

  const optionLooksLikeHeight = (name) => {
    const value = optionKey(name);
    return ['höhe', 'hoehe', 'height', 'size', 'taille', 'altezza', 'altura', 'hoogte', 'hauteur'].some((word) => value.includes(word));
  };

  const normalizeUrlPath = (value) => {
    if (!value) return '';
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return String(value).split('?')[0].replace(/\/$/, '');
    }
  };

  class IHColorCompare {
    constructor(root) {
      this.root = root;
      this.overlay = root.querySelector(SELECTORS.overlay);
      this.dialog = root.querySelector(SELECTORS.dialog);
      this.cards = Array.from(root.querySelectorAll(SELECTORS.card));
      this.filters = Array.from(root.querySelectorAll(SELECTORS.filter));
      this.applyButton = root.querySelector(SELECTORS.apply);
      this.closeButtons = Array.from(root.querySelectorAll(SELECTORS.close));
      this.currentColorText = root.querySelector(SELECTORS.currentColor);
      this.previewImage = root.querySelector(SELECTORS.previewImage);
      this.previewSwatch = root.querySelector(SELECTORS.previewSwatch);
      this.previewName = root.querySelector(SELECTORS.previewName);
      this.previewStatus = root.querySelector(SELECTORS.previewStatus);

      this.product = parseJSON(root.querySelector(SELECTORS.productJson), { variants: [], options: [] });
      this.config = parseJSON(root.querySelector(SELECTORS.configJson), {});
      this.t = Object.assign({}, DEFAULT_I18N, this.config.translations || {});
      this.source = this.config.source || root.dataset.ihColorSource || 'variant_option';
      this.colorIndex = Math.max(0, Number(this.config.optionPosition || 1) - 1);
      this.connectedProductsById = new Map();
      this.connectedProductsByHandle = new Map();
      this.pendingKey = this.getCurrentKey();
      this.previousFocus = null;
      this.isOpen = false;

      this.boundKeydown = this.handleKeydown.bind(this);
      this.boundExternalChange = this.handleExternalChange.bind(this);

      this.moveOverlayToBody();
      this.hydrateConnectedProducts();
      this.applyColorGroups();
      this.hydrateSwatches();
      this.bind();
      this.applyIncomingOptionsFromUrl();
      this.updateAll();
      // v9: no JS trigger relocation; triggers are rendered server-side.
    }

    get isConnectedSource() {
      return this.source === 'connected_products';
    }

    hydrateConnectedProducts() {
      // Product data for connected colors is embedded per card and read lazily.
      // This method intentionally exists so section re-renders can call it safely.
    }

    bind() {
      this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
      this.cards.forEach((card) => card.addEventListener('click', () => {
        this.pendingKey = this.keyForCard(card);
        this.updateAll();
      }));
      this.filters.forEach((button) => button.addEventListener('click', () => this.filter(button.dataset.ihColorFilter || 'all')));
      if (this.applyButton) this.applyButton.addEventListener('click', () => this.applyPendingSelection());

      const section = this.getSection();
      section.addEventListener('change', this.boundExternalChange);
      section.addEventListener('input', this.boundExternalChange);
    }

    moveOverlayToBody() {
      if (!this.overlay) return;

      this.overlay.dataset.ihColorCompareOwner = this.root.id || '';

      // If Shopify replaced the product section, an old overlay with the same owner
      // can remain in <body>. Remove it before moving the fresh overlay.
      if (this.root.id) {
        Array.from(document.body.querySelectorAll(`${SELECTORS.overlay}[data-ih-color-compare-owner="${cssEscape(this.root.id)}"]`)).forEach((overlay) => {
          if (overlay !== this.overlay) overlay.remove();
        });
      }

      if (this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
    }

    recoverOverlay() {
      if (this.overlay) return this.overlay;
      if (!this.root.id) return null;

      this.overlay = document.body.querySelector(`${SELECTORS.overlay}[data-ih-color-compare-owner="${cssEscape(this.root.id)}"]`);
      if (!this.overlay) return null;

      this.dialog = this.overlay.querySelector(SELECTORS.dialog);
      this.closeButtons = Array.from(this.overlay.querySelectorAll(SELECTORS.close));
      this.closeButtons.forEach((button) => {
        if (button.dataset.ihColorCloseBound === '1') return;
        button.dataset.ihColorCloseBound = '1';
        button.addEventListener('click', () => this.close());
      });

      return this.overlay;
    }

    getOpenButtons() {
      return Array.from(document.querySelectorAll(`${SELECTORS.open}[data-ih-color-compare-target="${cssEscape(this.root.id)}"]`));
    }

    getSection() {
      const sectionId = this.config.sectionId;
      if (sectionId) {
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (section) return section;
      }
      return this.root.closest('[id^="shopify-section-"]') || document;
    }

    getForm() {
      if (this.config.productFormId) {
        const form = document.getElementById(this.config.productFormId);
        if (form) return form;
      }
      const section = this.getSection();
      return section.querySelector('form[action*="/cart/add"]') || section.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    }

    getVariantIdField() {
      const form = this.getForm();
      const section = this.getSection();
      return (form && form.querySelector('[name="id"]')) || section.querySelector('[name="id"]') || document.querySelector('[name="id"]');
    }

    getCurrentVariantId() {
      const idField = this.getVariantIdField();
      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      return String((idField && idField.value) || urlVariant || this.config.selectedVariantId || '');
    }

    getVariantById(id) {
      return (this.product.variants || []).find((variant) => String(variant.id) === String(id)) || null;
    }

    findVariantByOptions(options) {
      return (this.product.variants || []).find((variant) => Array.isArray(variant.options) && variant.options.every((value, index) => value === options[index])) || null;
    }

    getCurrentVariant() {
      const exact = this.findVariantByOptions(this.getCurrentOptions({ preferNative: true }));
      if (exact) return exact;
      return this.getVariantById(this.getCurrentVariantId()) || (this.product.variants || []).find((v) => v.available) || (this.product.variants || [])[0] || null;
    }


    getConnectedProductData(card) {
      if (!card) return null;
      if (card.__ihConnectedProductData) return card.__ihConnectedProductData;

      const productId = String(card.dataset.productId || '');
      const productHandle = String(card.dataset.productHandle || '');
      let script = null;

      if (productId) {
        script = this.root.querySelector(`script[data-ih-connected-product-json][data-product-id="${cssEscape(productId)}"]`) ||
          document.querySelector(`script[data-ih-connected-product-json][data-product-id="${cssEscape(productId)}"]`);
      }
      if (!script && productHandle) {
        script = this.root.querySelector(`script[data-ih-connected-product-json][data-product-handle="${cssEscape(productHandle)}"]`) ||
          document.querySelector(`script[data-ih-connected-product-json][data-product-handle="${cssEscape(productHandle)}"]`);
      }

      const data = parseJSON(script, null);
      if (data && Array.isArray(data.variants)) {
        card.__ihConnectedProductData = data;
        return data;
      }
      return null;
    }

    currentOptionMap() {
      const names = this.product.options || [];
      const values = this.getCurrentOptions({ preferNative: true });
      const map = new Map();
      names.forEach((name, index) => {
        if (values[index]) map.set(optionKey(name), values[index]);
      });
      return { names, values, map };
    }

    targetOptionsForConnectedProduct(productData) {
      if (!productData || !Array.isArray(productData.options)) return [];
      const current = this.currentOptionMap();
      return productData.options.map((targetName, index) => {
        const byName = current.map.get(optionKey(targetName));
        return byName || current.values[index] || '';
      });
    }

    currentHeightValue() {
      const current = this.currentOptionMap();
      const heightIndex = current.names.findIndex(optionLooksLikeHeight);
      return heightIndex >= 0 ? current.values[heightIndex] || '' : '';
    }

    findConnectedVariantMatch(card) {
      const productData = this.getConnectedProductData(card);
      if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) {
        return { productData, variant: null, exact: false, height: false };
      }

      const targetOptions = this.targetOptionsForConnectedProduct(productData);
      const hasTargetOptions = targetOptions.some(Boolean);

      if (hasTargetOptions) {
        const exact = productData.variants.find((variant) => {
          if (!Array.isArray(variant.options)) return false;
          return targetOptions.every((value, index) => !value || optionValueKey(variant.options[index]) === optionValueKey(value));
        });
        if (exact) return { productData, variant: exact, exact: true, height: false };
      }

      const heightValue = this.currentHeightValue();
      const targetHeightIndex = Array.isArray(productData.options) ? productData.options.findIndex(optionLooksLikeHeight) : -1;
      if (heightValue && targetHeightIndex >= 0) {
        const heightVariants = productData.variants.filter((variant) => Array.isArray(variant.options) && optionValueKey(variant.options[targetHeightIndex]) === optionValueKey(heightValue));
        if (heightVariants.length) {
          return { productData, variant: heightVariants.find((variant) => variant.available) || heightVariants[0], exact: false, height: true };
        }
      }

      return { productData, variant: productData.variants.find((variant) => variant.available) || productData.variants[0] || null, exact: false, height: false };
    }

    updateConnectedCardImage(card) {
      if (!this.isConnectedSource || !card) return;
      const image = this.imageForCard(card);
      if (!image) return;
      const img = card.querySelector('.ih-color-compare-card__visual img');
      if (!img) return;
      if (img.getAttribute('src') !== image) {
        img.setAttribute('src', image);
        img.removeAttribute('srcset');
      }
    }

    connectedCardFor({ productId = '', productHandle = '', productUrl = '' } = {}) {
      const targetPath = normalizeUrlPath(productUrl);
      return this.cards.find((card) => {
        if (productId && String(card.dataset.productId || '') === String(productId)) return true;
        if (productHandle && String(card.dataset.productHandle || '') === String(productHandle)) return true;
        if (targetPath && normalizeUrlPath(card.dataset.productUrl || '') === targetPath) return true;
        return false;
      }) || null;
    }

    buildConnectedProductUrl(productUrl, card = null) {
      const url = new URL(productUrl || (card && card.dataset.productUrl) || window.location.href, window.location.origin);
      const match = card ? this.findConnectedVariantMatch(card) : { variant: null };

      if (match.variant && match.variant.id) {
        url.searchParams.set('variant', match.variant.id);
      }

      const options = this.getCurrentOptions({ preferNative: true });
      const optionNames = this.product.options || [];
      url.searchParams.set('ihcc', '1');
      optionNames.forEach((name, index) => {
        if (options[index]) {
          url.searchParams.set(`ihcc_name_${index}`, name);
          url.searchParams.set(`ihcc_option_${index}`, options[index]);
        }
      });

      return url.toString();
    }

    navigateToConnectedProductUrl(productUrl, meta = {}) {
      const productId = String(meta.productId || '');
      const productHandle = String(meta.productHandle || '');
      const currentProductId = String(this.config.productId || '');
      if (productId && productId === currentProductId) {
        window.__IHColorCompareNavigating = false;
        return;
      }
      const card = this.connectedCardFor({ productId, productHandle, productUrl });
      window.location.href = this.buildConnectedProductUrl(productUrl, card);
    }

    getCurrentColor() {
      if (this.isConnectedSource) return this.config.selectedColor || '';
      const options = this.getCurrentOptions({ preferNative: true });
      if (options[this.colorIndex]) return options[this.colorIndex];
      const variant = this.getCurrentVariant();
      return variant && Array.isArray(variant.options) ? variant.options[this.colorIndex] || '' : this.config.selectedColor || '';
    }

    getCurrentKey() {
      if (this.isConnectedSource) return String(this.config.productId || this.config.productHandle || this.config.selectedColor || '');
      return this.getCurrentColor();
    }

    keyForCard(card) {
      if (!card) return '';
      return this.isConnectedSource ? String(card.dataset.productId || card.dataset.productUrl || card.dataset.color || '') : String(card.dataset.color || '');
    }

    selectedCard() {
      return this.cards.find((card) => this.keyForCard(card) === this.pendingKey) || this.cards[0] || null;
    }

    connectedTriggerTargetScore(element, trigger) {
      if (!element || !isActuallyVisible(element)) return -1;
      if (element.closest('.ih-color-compare') || (this.overlay && this.overlay.contains(element))) return -1;
      if (element.contains(trigger)) return -1;

      const rawText = String(element.textContent || '').replace(/\s+/g, ' ').trim();
      const text = normalize(rawText);
      if (!text || text.length > 140) return -1;
      if (text.includes(normalize(this.config.translations && this.config.translations.trigger || 'Alle Farben vergleichen'))) return -1;
      if (!labelLooksLikeMainColor(rawText)) return -1;

      let score = 1000;
      score -= Math.min(text.length, 120);
      if (/^(farbe|color|colour|couleur|colore|kleur)\s*[:：]/i.test(rawText.trim())) score += 300;
      if (element.matches('legend, label, .form__label')) score += 180;
      if (element.querySelector('input, button, select') && !element.matches('legend, label, .form__label')) score -= 180;
      if (trigger && (element.compareDocumentPosition(trigger) & Node.DOCUMENT_POSITION_FOLLOWING)) score += 60;
      return score;
    }

    findConnectedColorTarget(trigger) {
      const section = this.getSection();
      const scope = section.querySelector('variant-selects') || section;

      const textTarget = this.findConnectedColorTextTarget(scope, trigger);
      if (textTarget) return textTarget;

      const selectors = [
        'legend',
        'label',
        '.form__label',
        '[class*="label"]',
        '[class*="color"]',
        '[class*="farbe"]',
        '[data-selected-value]',
        'p',
        'span',
        'div'
      ].join(',');

      const candidates = Array.from(scope.querySelectorAll(selectors))
        .map((element) => ({ element, score: this.connectedTriggerTargetScore(element, trigger) }))
        .filter((item) => item.score >= 0)
        .sort((a, b) => b.score - a.score);

      return candidates.length ? candidates[0].element : null;
    }

    findConnectedColorTextTarget(scope, trigger) {
      if (!scope || !window.NodeFilter) return null;

      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          const text = String(node.nodeValue || '').replace(/\s+/g, ' ').trim();
          if (!text || text.length > 80) return NodeFilter.FILTER_REJECT;
          if (!labelLooksLikeMainColor(text)) return NodeFilter.FILTER_REJECT;

          const element = node.parentElement;
          if (!element) return NodeFilter.FILTER_REJECT;
          if (element.closest('.ih-color-compare') || (this.overlay && this.overlay.contains(element))) return NodeFilter.FILTER_REJECT;
          if (trigger && (element === trigger || element.contains(trigger))) return NodeFilter.FILTER_REJECT;
          if (trigger && element.compareDocumentPosition && !(element.compareDocumentPosition(trigger) & Node.DOCUMENT_POSITION_FOLLOWING)) return NodeFilter.FILTER_REJECT;

          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const matches = [];
      let node;
      while ((node = walker.nextNode())) {
        matches.push(node.parentElement);
      }

      if (!matches.length) return null;
      return matches[matches.length - 1];
    }

    normalizeTargetRow(target) {
      if (!target) return null;
      if (target.matches('legend, label, .form__label')) return target;
      const parentLabel = target.closest('legend, label, .form__label');
      if (parentLabel) return parentLabel;
      return target.parentElement || target;
    }

    placeConnectedTrigger() {
      // v9: trigger placement is server-rendered in product-variant-picker / product-variant-picker-custom.
      return;
    }

    placeConnectedTriggerFallback() {
      // v9: no fallback re-parenting; connected trigger is server-rendered.
      return;
    }

    locateOptionContainer(optionName) {
      const section = this.getSection();
      const optionNameNorm = normalize(optionName);
      const selectors = ['fieldset', '.product-form__input', '.selector-wrapper', '[data-option-name]', '[data-product-option]', '[data-option-index]', 'variant-radios', 'variant-selects'].join(',');
      return Array.from(section.querySelectorAll(selectors)).find((candidate) => {
        if (candidate.closest('.ih-color-compare') || (this.overlay && this.overlay.contains(candidate))) return false;
        const dataNames = [candidate.dataset.optionName, candidate.dataset.productOption, candidate.getAttribute('data-option-name')].map(normalize);
        if (dataNames.some((name) => name && (name === optionNameNorm || name.includes(optionNameNorm)))) return true;
        const header = this.findOptionHeader(candidate);
        return !!(header && normalize(header.textContent).includes(optionNameNorm));
      }) || null;
    }

    findOptionHeader(container) {
      if (!container) return null;
      return container.querySelector('legend') || container.querySelector('.form__label') || container.querySelector('.product-form__input__label') || container.querySelector('.selector-wrapper > label') || container.querySelector('.option-title') || container.querySelector('label');
    }

    collectSearchRoots(optionName) {
      return uniqueNodes([this.locateOptionContainer(optionName), this.getForm(), this.getSection()]);
    }

    inputLooksLikeOption(input, optionName) {
      if (!input || input.closest('.ih-color-compare') || (this.overlay && this.overlay.contains(input))) return false;
      const optionNameNorm = normalize(optionName);
      const name = normalize(input.getAttribute('name'));
      const dataName = normalize(input.dataset.optionName || input.dataset.name || '');
      if (name === optionNameNorm || name.includes(optionNameNorm) || dataName === optionNameNorm || dataName.includes(optionNameNorm)) return true;
      const wrapper = input.closest('fieldset, .product-form__input, .selector-wrapper, [data-option-name], [data-product-option], [data-option-index]');
      const header = this.findOptionHeader(wrapper);
      return !!(header && normalize(header.textContent).includes(optionNameNorm));
    }

    selectLooksLikeOption(select, optionName) {
      if (!select || select.closest('.ih-color-compare') || (this.overlay && this.overlay.contains(select))) return false;
      const optionNameNorm = normalize(optionName);
      const name = normalize(select.getAttribute('name'));
      const dataName = normalize(select.dataset.optionName || select.dataset.name || '');
      if (name === optionNameNorm || name.includes(optionNameNorm) || dataName === optionNameNorm || dataName.includes(optionNameNorm)) return true;
      const label = select.id ? document.querySelector(`label[for="${cssEscape(select.id)}"]`) : null;
      if (label && normalize(label.textContent).includes(optionNameNorm)) return true;
      const wrapper = select.closest('fieldset, .selector-wrapper, .product-form__input, [data-option-name], [data-product-option], [data-option-index]');
      const header = this.findOptionHeader(wrapper);
      return !!(header && normalize(header.textContent).includes(optionNameNorm));
    }

    readNativeOptionValue(optionName) {
      for (const root of this.collectSearchRoots(optionName)) {
        const radio = Array.from(root.querySelectorAll('input[type="radio"]')).find((input) => input.checked && this.inputLooksLikeOption(input, optionName));
        if (radio) return radio.value;
        const select = Array.from(root.querySelectorAll('select')).find((item) => this.selectLooksLikeOption(item, optionName));
        if (select) return select.value;
      }
      return '';
    }

    getCurrentOptions({ preferNative = false } = {}) {
      const optionNames = this.product.options || [];
      const nativeOptions = optionNames.map((name) => this.readNativeOptionValue(name) || '');
      if (preferNative && nativeOptions.some(Boolean)) return nativeOptions;
      const variant = this.getVariantById(this.getCurrentVariantId());
      return variant && Array.isArray(variant.options) ? [...variant.options] : nativeOptions;
    }

    applyColorGroups() {
      this.cards.forEach((card) => {
        const groups = colorGroupsForName(card.dataset.color || '').join(' ');
        if (groups) {
          card.dataset.group = groups;
          card.dataset.groups = groups;
        }
      });
    }

    hydrateSwatches() {
      this.cards.forEach((card) => {
        const swatch = card.querySelector('.ih-color-compare-card__swatch');
        if (!swatch) return;
        const style = swatch.getAttribute('style') || '';
        if (!style.includes('--ih-swatch-color') && !style.includes('--ih-swatch-image')) {
          swatch.style.setProperty('--ih-swatch-color', fallbackColorForName(card.dataset.color));
        }
      });
    }

    findVariantForColor(color) {
      if (this.isConnectedSource) return { variant: null, exact: false };
      const variants = this.product.variants || [];
      if (!variants.length || !color) return { variant: null, exact: false };
      const options = this.getCurrentOptions({ preferNative: true });
      options[this.colorIndex] = color;
      const exact = this.findVariantByOptions(options);
      if (exact) return { variant: exact, exact: true };
      const sameColor = variants.filter((v) => Array.isArray(v.options) && v.options[this.colorIndex] === color);
      return { variant: sameColor.find((v) => v.available) || sameColor[0] || null, exact: false };
    }

    statusForVariantColor(color) {
      const result = this.findVariantForColor(color);
      const variant = result.variant;
      if (!variant) return { label: this.t.unavailable, state: 'soldout' };
      if (result.exact && variant.available) return { label: this.t.available, state: 'available' };
      if (result.exact && !variant.available) return { label: this.t.soldoutVariant, state: 'soldout' };
      if (!result.exact && variant.available) return { label: this.t.partial, state: 'partial' };
      return { label: this.t.unavailable, state: 'soldout' };
    }

    statusForCard(card) {
      if (this.isConnectedSource) {
        const match = this.findConnectedVariantMatch(card);
        if (match.variant) {
          return { label: match.variant.available ? this.t.available : this.t.soldoutVariant, state: match.variant.available ? 'available' : 'soldout' };
        }
        const available = card && card.dataset.productAvailable !== 'false';
        return { label: available ? this.t.available : this.t.unavailable, state: available ? 'available' : 'soldout' };
      }
      return this.statusForVariantColor(card ? card.dataset.color : '');
    }
    imageUrlFromVariant(variant) {
      if (!variant) return '';
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      if (variant.featured_image && variant.featured_image.url) return variant.featured_image.url;
      if (variant.featured_media && variant.featured_media.preview_image) {
        if (typeof variant.featured_media.preview_image === 'string') return variant.featured_media.preview_image;
        if (variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
      }
      if (variant.image && typeof variant.image === 'string') return variant.image;
      if (variant.image && variant.image.src) return variant.image.src;
      return '';
    }

    imageUrlFromProduct(productData) {
      if (!productData) return '';
      if (typeof productData.featured_image === 'string') return productData.featured_image;
      if (productData.featured_image && productData.featured_image.src) return productData.featured_image.src;
      if (productData.featured_image && productData.featured_image.url) return productData.featured_image.url;
      if (productData.featured_media && productData.featured_media.preview_image) {
        if (typeof productData.featured_media.preview_image === 'string') return productData.featured_media.preview_image;
        if (productData.featured_media.preview_image.src) return productData.featured_media.preview_image.src;
      }
      return '';
    }

    imageForCard(card) {
      if (!card) return '';
      if (this.isConnectedSource) {
        const match = this.findConnectedVariantMatch(card);
        const matchedImage = this.imageUrlFromVariant(match.variant);
        if (matchedImage) return matchedImage;
        const productImage = this.imageUrlFromProduct(match.productData);
        if (productImage) return productImage;
      } else {
        const result = this.findVariantForColor(card.dataset.color || '');
        const variantImage = this.imageUrlFromVariant(result.variant);
        if (variantImage) return variantImage;
      }
      if (card.dataset.previewImage) return card.dataset.previewImage;
      return this.imageUrlFromProduct(this.product);
    }
    updateAll() {
      if (!this.isOpen) this.pendingKey = this.getCurrentKey() || this.pendingKey;
      const currentColor = this.getCurrentColor();
      if (this.currentColorText) this.currentColorText.textContent = currentColor || '—';
      this.getOpenButtons().forEach((button) => button.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false'));

      this.cards.forEach((card) => {
        const selected = this.keyForCard(card) === this.pendingKey;
        const status = this.statusForCard(card);
        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-unavailable', status.state === 'soldout');
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        this.updateConnectedCardImage(card);
        const statusEl = card.querySelector(SELECTORS.status);
        if (statusEl) {
          statusEl.textContent = status.label;
          statusEl.dataset.state = status.state;
        }
      });
      this.updatePreview();
    }

    updatePreview() {
      const card = this.selectedCard();
      if (!card) return;
      const color = card.dataset.color || '';
      const image = this.imageForCard(card);
      const status = this.statusForCard(card);
      const cardSwatch = card.querySelector('.ih-color-compare-card__swatch');

      if (this.previewName) this.previewName.textContent = color || '—';
      if (this.previewStatus) {
        this.previewStatus.textContent = status.label;
        this.previewStatus.dataset.state = status.state;
      }
      if (this.previewImage) {
        if (image) {
          this.previewImage.src = image;
          this.previewImage.alt = `${this.product.title || 'Product'} in ${color}`;
          this.previewImage.hidden = false;
        } else {
          this.previewImage.hidden = true;
          this.previewImage.removeAttribute('src');
        }
      }
      if (this.previewSwatch && cardSwatch) {
        const swatchImage = cardSwatch.style.getPropertyValue('--ih-swatch-image');
        const swatchColor = cardSwatch.style.getPropertyValue('--ih-swatch-color') || fallbackColorForName(color);
        if (swatchImage) this.previewSwatch.style.setProperty('--ih-swatch-image', swatchImage);
        else this.previewSwatch.style.removeProperty('--ih-swatch-image');
        this.previewSwatch.style.setProperty('--ih-swatch-color', swatchColor);
      }
    }

    filter(group) {
      this.filters.forEach((button) => button.setAttribute('aria-pressed', button.dataset.ihColorFilter === group ? 'true' : 'false'));
      this.cards.forEach((card) => {
        const groups = String(card.dataset.groups || card.dataset.group || '')
          .split(/[\s,|]+/)
          .map((item) => item.trim())
          .filter(Boolean);
        const show = group === 'all' || groups.includes(group);
        card.classList.toggle('is-hidden', !show);
      });
    }

    open(trigger = null) {
      this.recoverOverlay();
      if (!this.overlay || !this.dialog) return;
      this.previousFocus = trigger || document.activeElement;
      this.isOpen = true;
      this.pendingKey = this.getCurrentKey() || this.pendingKey;
      this.updateAll();
      this.overlay.hidden = false;
      document.body.classList.add('ih-color-compare-open');
      window.requestAnimationFrame(() => {
        this.overlay.classList.add('is-open');
        this.dialog.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', this.boundKeydown);
    }

    close() {
      if (!this.overlay) return;
      this.isOpen = false;
      this.overlay.classList.remove('is-open');
      document.body.classList.remove('ih-color-compare-open');
      document.removeEventListener('keydown', this.boundKeydown);
      this.getOpenButtons().forEach((button) => button.setAttribute('aria-expanded', 'false'));
      window.setTimeout(() => { if (!this.isOpen) this.overlay.hidden = true; }, 240);
      if (this.previousFocus && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
    }

    handleKeydown(event) {
      if (!this.isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusable(this.dialog);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleExternalChange(event) {
      if (this.root.contains(event.target) || (this.overlay && this.overlay.contains(event.target))) return;
      window.setTimeout(() => {
        this.updateAll();
        // v9: no JS trigger relocation; triggers are rendered server-side.
      }, 0);
    }

    applyPendingSelection() {
      const card = this.selectedCard();
      if (!card) return;

      if (this.isConnectedSource) {
        this.applyConnectedProductCard(card);
        return;
      }

      const color = card.dataset.color || '';
      const result = this.findVariantForColor(color);
      const targetVariant = result.variant;
      if (targetVariant) this.syncNativeVariantOptions(targetVariant);
      else this.setNativeOptionValue(this.config.optionName || 'Color', color);

      window.setTimeout(() => {
        const finalVariant = targetVariant || this.getCurrentVariant();
        if (finalVariant) {
          this.updateVariantId(finalVariant.id);
          this.updateUrl(finalVariant.id);
          this.dispatchVariantEvents(finalVariant);
        }
        this.updateAll();
      }, 80);
      this.close();
    }

    applyConnectedProductCard(card) {
      const productUrl = card.dataset.productUrl;
      const productId = String(card.dataset.productId || '');
      const currentProductId = String(this.config.productId || '');

      if (!productUrl || productId === currentProductId) {
        this.close();
        return;
      }

      window.location.href = this.buildConnectedProductUrl(productUrl, card);
    }
    applyIncomingOptionsFromUrl() {
      const params = new URLSearchParams(window.location.search);
      if (params.get('ihcc') !== '1') return;

      const optionNames = this.product.options || [];
      let changed = false;
      optionNames.forEach((fallbackName, index) => {
        const name = params.get(`ihcc_name_${index}`) || fallbackName;
        const value = params.get(`ihcc_option_${index}`);
        if (name && value) changed = this.setNativeOptionValue(name, value) || changed;
      });

      if (!changed) return;

      window.setTimeout(() => {
        const variant = this.findVariantByOptions(this.getCurrentOptions({ preferNative: true })) || this.getCurrentVariant();
        if (variant) {
          this.updateVariantId(variant.id);
          this.dispatchVariantEvents(variant);
          const cleanUrl = new URL(window.location.href);
          Array.from(cleanUrl.searchParams.keys()).forEach((key) => {
            if (key === 'ihcc' || key.startsWith('ihcc_')) cleanUrl.searchParams.delete(key);
          });
          cleanUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: cleanUrl.toString() }, '', cleanUrl.toString());
        }
      }, 120);
    }

    syncNativeVariantOptions(variant) {
      if (!variant || !Array.isArray(variant.options)) return false;
      let changed = false;
      (this.product.options || []).forEach((optionName, index) => {
        changed = this.setNativeOptionValue(optionName, variant.options[index]) || changed;
      });
      return changed;
    }

    setNativeOptionValue(optionName, value) {
      if (!optionName || !value) return false;
      const valueNorm = normalize(value);
      let changed = false;

      for (const root of this.collectSearchRoots(optionName)) {
        const radio = Array.from(root.querySelectorAll('input[type="radio"]')).find((input) => this.inputLooksLikeOption(input, optionName) && normalize(input.value) === valueNorm);
        if (radio) {
          const label = radio.id ? root.querySelector(`label[for="${cssEscape(radio.id)}"]`) || document.querySelector(`label[for="${cssEscape(radio.id)}"]`) : null;
          if (label && typeof label.click === 'function') label.click();
          else if (typeof radio.click === 'function') radio.click();
          if (!radio.checked) radio.checked = true;
          dispatchNativeChange(radio);
          changed = true;
          break;
        }
      }

      if (!changed) {
        for (const root of this.collectSearchRoots(optionName)) {
          const select = Array.from(root.querySelectorAll('select')).find((item) => this.selectLooksLikeOption(item, optionName) && Array.from(item.options).some((option) => normalize(option.value) === valueNorm || normalize(option.textContent) === valueNorm));
          if (select) {
            const option = Array.from(select.options).find((item) => normalize(item.value) === valueNorm || normalize(item.textContent) === valueNorm);
            if (option) {
              select.value = option.value;
              dispatchNativeChange(select);
              changed = true;
              break;
            }
          }
        }
      }

      return changed;
    }

    updateVariantId(id) {
      const field = this.getVariantIdField();
      if (!field || !id) return;
      field.value = String(id);
      dispatchNativeChange(field);
    }

    updateUrl(id) {
      if (!id || !window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    dispatchVariantEvents(variant) {
      const detail = { variant, product: this.product, sectionId: this.config.sectionId, source: 'ih-color-compare' };
      const section = this.getSection();
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail }));
      section.dispatchEvent(new CustomEvent('product:variant-change', { bubbles: true, detail }));
      section.dispatchEvent(new CustomEvent('variant-change', { bubbles: true, detail }));
      document.dispatchEvent(new CustomEvent('ih:variant-change', { detail }));
    }
  }

  const INSTANCE_PROP = '__IHColorCompareV9';

  const createOrRefresh = (root) => {
    if (!root || !root.matches || !root.matches(SELECTORS.root)) return null;

    if (!root[INSTANCE_PROP]) {
      root[INSTANCE_PROP] = new IHColorCompare(root);
    } else {
      root[INSTANCE_PROP].moveOverlayToBody();
      root[INSTANCE_PROP].updateAll();
    }

    return root[INSTANCE_PROP];
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope.matches && scope.matches(SELECTORS.root)) roots.push(scope);
    roots.push(...Array.from(scope.querySelectorAll ? scope.querySelectorAll(SELECTORS.root) : []));
    uniqueNodes(roots).forEach(createOrRefresh);
  };

  const resolveInstanceForTrigger = (trigger) => {
    const targetId = trigger && trigger.dataset.ihColorCompareTarget;
    const source = trigger && trigger.dataset.ihColorCompareSource;
    const section = trigger && trigger.closest('[id^="shopify-section-"]');
    let root = null;

    if (targetId) {
      root = document.getElementById(targetId);
      if (!root || !root.matches || !root.matches(SELECTORS.root)) {
        root = document.querySelector(`${SELECTORS.root}#${cssEscape(targetId)}`);
      }
    }

    if (!root) {
      init(document);
      if (targetId) root = document.getElementById(targetId);
    }

    if (!root && source) {
      const bySource = `${SELECTORS.root}[data-ih-color-source="${cssEscape(source)}"]`;
      root = (section && section.querySelector(bySource)) || document.querySelector(bySource);
    }

    if (!root) {
      root = (section && section.querySelector(SELECTORS.root)) || document.querySelector(SELECTORS.root);
    }

    return root ? createOrRefresh(root) : null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTORS.open);
    if (!trigger) return;

    // Stop the label/variant picker from swallowing this click before the modal opens.
    event.preventDefault();
    event.stopPropagation();

    const instance = resolveInstanceForTrigger(trigger);
    if (!instance) return;

    instance.open(trigger);
  }, true);

  const getConnectedSwitchInput = (target) => {
    const directInput = target && target.closest && target.closest('variant-selects-cust input[data-ih-connected-product-switch], variant-selects-cust input[data-ih-connected-swatch-input], variant-selects-cust input[data-montage_checkbox="true"]');
    if (directInput) return directInput;

    const label = target && target.closest && target.closest('variant-selects-cust label[for]');
    if (!label) return null;

    const input = document.getElementById(label.getAttribute('for'));
    if (!input) return null;
    if (input.matches('variant-selects-cust input[data-ih-connected-product-switch], variant-selects-cust input[data-ih-connected-swatch-input], variant-selects-cust input[data-montage_checkbox="true"]')) return input;
    return null;
  };

  const handleConnectedNativeSwitch = (event) => {
    const input = getConnectedSwitchInput(event.target);
    if (!input) return;

    const productUrl = input.dataset.productUrl || input.dataset.ihConnectedProductUrl || input.value;
    if (!productUrl || !/\//.test(productUrl)) return;

    event.preventDefault();
    event.stopPropagation();

    if (window.__IHColorCompareNavigating) return;
    window.__IHColorCompareNavigating = true;

    const section = input.closest('[id^="shopify-section-"]');
    init(section || document);

    const root = (section && section.querySelector(`${SELECTORS.root}[data-ih-color-source="connected_products"]`)) ||
      document.querySelector(`${SELECTORS.root}[data-ih-color-source="connected_products"]`);
    const instance = root ? createOrRefresh(root) : null;

    if (instance) {
      instance.navigateToConnectedProductUrl(productUrl, {
        productId: input.dataset.productId || input.dataset.ihConnectedProductId || '',
        productHandle: input.dataset.productHandle || input.dataset.ihConnectedProductHandle || ''
      });
    } else {
      window.location.href = new URL(productUrl, window.location.origin).toString();
    }
  };

  document.addEventListener('click', handleConnectedNativeSwitch, true);
  document.addEventListener('change', handleConnectedNativeSwitch, true);

  let observerTimer = null;
  const scheduleInit = () => {
    if (observerTimer) window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(() => init(document), 60);
  };

  const startObserver = () => {
    if (window.__IHColorCompareObserverV9 || !window.MutationObserver || !document.body) return;

    window.__IHColorCompareObserverV9 = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          const relevantSelector = `${SELECTORS.root}, ${SELECTORS.open}, variant-selects, .product-form__input, [class*="color"], [class*="farbe"]`;
          if (node.matches(relevantSelector) || node.querySelector(relevantSelector)) {
            scheduleInit();
            return;
          }
        }
      }
    });

    window.__IHColorCompareObserverV9.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      startObserver();
    });
  } else {
    init();
    startObserver();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    scheduleInit();
  });
})();
